/**
 * App エントリーポイント
 */
// 外部モジュールをインポート
import React from "react";
import {Provider} from "react-redux";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

// ライブラリをインポート
import store from "lib/store";
import {storageInit} from "lib/storage";

// スタイルシートをインポート
import "./style.scss";
// 描画コンポーネントをインポート
import App from "./App";

// Session Storageを初期化
storageInit("u");


const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
